import { render, staticRenderFns } from "./ContentsComp.vue?vue&type=template&id=75ff4b50&scoped=true&"
import script from "./ContentsComp.vue?vue&type=script&lang=js&"
export * from "./ContentsComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ff4b50",
  null
  
)

export default component.exports